<div class="wrapper">
  <div class="map-container">
    <div class="map-frame">
      <div id="map"></div>
    </div>
  </div>
  <div class="loader" [ngClass]="{'show': loading}">
    <div class="d-flex justify-content-start centered">
      <div class="spinner-border text-warning" style="width: 3rem; height: 3rem;" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <strong class="ml-5 align-middle" style="height: 3rem; line-height: 3rem;">Loading...</strong>
    </div>
  </div>
</div>
